module.exports = __webpack_public_path__ + "static/rhubarb-&-strawberry-b9a439fef0e761e5d00a13014331123b.png";